import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if we're impersonating - if so, restore original admin instead of logging out
      const isImpersonating = localStorage.getItem('impersonating') === 'true';
      const originalToken = localStorage.getItem('original_token');
      const originalUser = localStorage.getItem('original_user');
      
      if (isImpersonating && originalToken && originalUser) {
        // Restore original admin credentials
        localStorage.setItem('token', originalToken);
        localStorage.setItem('user', originalUser);
        localStorage.removeItem('impersonating');
        localStorage.removeItem('original_token');
        localStorage.removeItem('original_user');
        // Redirect to users page with error message
        window.location.href = '/users?error=impersonation_failed';
      } else {
        // Normal logout flow - but don't redirect if already on login page
        if (!window.location.pathname.includes('/login')) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('impersonating');
          localStorage.removeItem('original_token');
          localStorage.removeItem('original_user');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
